import { CommandIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Shortcut = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <CommandIcon size={Sizes[size]} {...rest} color={fill} />;
};

Shortcut.displayName = 'Shortcut';
